import { Controller } from '@hotwired/stimulus';

// Quick-apply resume step, attached to the <turbo-frame> around the step.
// A file picked in the Ui::DocumentUploaderComponent submits the `form`
// target; the frame swaps in the re-rendered step (CV list, selection, gating
// and upload errors all server-rendered) and Stimulus reconnects the
// controllers inside it.
//
// Responses that carry no frame to swap are handled here: a redirect (gate,
// eligibility, authorization) leaves the step as a full page load, anything
// else lands on the `error` target.

const UPLOAD_FAILED = 'Upload failed. Please try again.';

export default class extends Controller {
  static targets = ['form', 'error'];

  upload(event) {
    this.showError('');
    this.setUploaderLoading(event.target, true);
    this.formTarget.requestSubmit();
  }

  // A swapped frame brings its own uploader; only a response that left the
  // DOM alone needs the loading state cleared by hand.
  submitEnd(event) {
    const { success, fetchResponse } = event.detail;
    if (success || (fetchResponse && fetchResponse.statusCode === 422)) return;

    this.setUploaderLoading(this.uploader, false);
    this.showError(UPLOAD_FAILED);
  }

  frameMissing(event) {
    event.preventDefault();

    const { response } = event.detail;
    if (response.redirected) {
      window.location.assign(response.url);
      return;
    }

    this.showError(UPLOAD_FAILED);
  }

  setUploaderLoading(uploader, loading) {
    if (!uploader || !uploader.isConnected) return;

    this.uploader = uploader;
    uploader.dataset.documentUploaderComponentLoadingValue = String(loading);
  }

  showError(message) {
    if (!this.hasErrorTarget) return;

    this.errorTarget.textContent = message;
    this.errorTarget.hidden = message === '';
  }
}
